import React, {useEffect, useState} from 'react';
import {Card, Table, Badge, Dropdown} from 'react-bootstrap';
import {
    filterTakeawayList,
    updateTakeawaySettings,
    getViewDeliveryDetails, // Added missing import
} from '../../../services/OrderService';
import DeliveryDetails from './DeliveryDetails';

const svg1 = (
    <svg width='20px' height='20px' viewBox='0 0 24 24' version='1.1'>
        <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <rect x='0' y='0' width='24' height='24'></rect>
            <circle fill='#000000' cx='5' cy='12' r='2'></circle>
            <circle fill='#000000' cx='12' cy='12' r='2'></circle>
            <circle fill='#000000' cx='19' cy='12' r='2'></circle>
        </g>
    </svg>
);

const TakeawayList = props => {
    const {takeawayList, getUpcomingTakeaways} = props;
    const [filteredList, setFilteredList] = useState(takeawayList);
    const [selectedFilter, setSelectedFilter] = useState('All Status');
    const [viewDetails, setViewDetails] = useState({});
    const [expandedRows, setExpandedRows] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});

    useEffect(() => {
        getUpcomingTakeaways();
    }, [getUpcomingTakeaways]);

    useEffect(() => {
        setFilteredList(takeawayList);
    }, [takeawayList]);

    const updateTakeawayStatus = (ord_id, status) => {
        updateTakeawaySettings({ord_id, status})
            .then(() => getUpcomingTakeaways())
            .catch(err => console.error('Error updating status:', err));
    };

    const handleFilterTakeaway = (status, filterLabel) => {
        setSelectedFilter(filterLabel);

        if (status === 'all') {
            // Show all deliveries
            setFilteredList(takeawayList);
        } else {
            // Filter locally first for immediate response
            const filtered = takeawayList?.filter(takeaway => {
                switch (status) {
                    case 'restaurant_confirmed':
                        return (
                            takeaway.status === 'Confirmed' ||
                            takeaway.status === 'restaurant_confirmed'
                        );
                    case 'restaurant_cancelled':
                        return (
                            takeaway.status === 'Cancelled' ||
                            takeaway.status === 'restaurant_cancelled'
                        );
                    case 'pending':
                        return (
                            takeaway.status === 'Pending' ||
                            takeaway.status === 'restaurant_rejected'
                        );
                    case 'order_completed':
                        return (
                            takeaway.status === 'Completed' ||
                            takeaway.status === 'Order Completed'
                        );
                    default:
                        return true;
                }
            });
            setFilteredList(filtered);

            // Also call API if needed for server-side filtering
            filterTakeawayList(status)
                .then(res => {
                    if (res && res.data) {
                        setFilteredList(res.data);
                    }
                })
                .catch(err =>
                    console.error('Error filtering delivery list:', err)
                );
        }
    };

    const ViewDetails = ord_id => {
        if (expandedRows[ord_id]) {
            setExpandedRows(prev => ({
                ...prev,
                [ord_id]: false,
            }));
            return;
        }

        if (viewDetails[ord_id]) {
            setExpandedRows(prev => ({
                ...prev,
                [ord_id]: true,
            }));
            return;
        }

        setLoadingDetails(prev => ({
            ...prev,
            [ord_id]: true,
        }));

        getViewDeliveryDetails(ord_id)
            .then(res => {
                console.log('API Response:', res[0]);
                if (res && res.length > 0) {
                    setViewDetails(prev => ({
                        ...prev,
                        [ord_id]: res[0],
                    }));
                    setExpandedRows(prev => ({
                        ...prev,
                        [ord_id]: true,
                    }));
                } else {
                    console.warn('No data received for order:', ord_id);
                    setExpandedRows(prev => ({
                        ...prev,
                        [ord_id]: true,
                    }));
                }
            })
            .catch(err => {
                console.error('Error getting delivery details:', err);
                setExpandedRows(prev => ({
                    ...prev,
                    [ord_id]: true,
                }));
            })
            .finally(() => {
                setLoadingDetails(prev => ({
                    ...prev,
                    [ord_id]: false,
                }));
            });
    };

    const closeDetails = ord_id => {
        setExpandedRows(prev => ({
            ...prev,
            [ord_id]: false,
        }));
    };

    return (
        <>
            <div className='d-sm-flex mb-lg-4 mb-2'>
                <Dropdown className='dropdown mb-2 ml-auto mr-3'>
                    <Dropdown.Toggle
                        className='i-false btn btn-primary btn-rounded light'
                        data-toggle='dropdown'
                        aria-expanded='false'
                    >
                        <i className='las la-bolt scale5 mr-3' />
                        {selectedFilter}
                        <i className='las la-angle-down ml-3' />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='dropdown-menu dropdown-menu-center'>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterTakeaway('all', 'All Status')
                            }
                        >
                            <span className='text-primary'>All Status</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterTakeaway(
                                    'restaurant_confirmed',
                                    'Booking Confirmed'
                                )
                            }
                        >
                            <span className='text-primary'>
                                Booking Confirmed
                            </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterTakeaway(
                                    'restaurant_cancelled',
                                    'Booking Cancelled'
                                )
                            }
                        >
                            <span className='text-warning'>
                                Booking Cancelled
                            </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterTakeaway(
                                    'pending',
                                    'Booking Rejected'
                                )
                            }
                        >
                            <span className='text-error'>Booking Pending</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                            className='dropdown-item'
                            onClick={() =>
                                handleFilterTakeaway(
                                    'order_completed',
                                    'Order Completed'
                                )
                            }
                        >
                            <span className='text-success'>
                                Order Completed
                            </span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <Card>
                <Card.Header>
                    <Card.Title>Live Skip the Queue Orders</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table>
                        <thead>
                            <tr>
                                <th>
                                    <strong>DELIVERY NO.</strong>
                                </th>
                                <th>
                                    <strong>DATE</strong>
                                </th>
                                <th>
                                    <strong>SLOT</strong>
                                </th>
                                <th>
                                    <strong>CUSTOMER</strong>
                                </th>
                                <th>
                                    <strong>AMOUNT</strong>
                                </th>
                                <th>
                                    <strong>STATUS</strong>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredList && filteredList.length > 0 ? (
                                filteredList.map(each => (
                                    <React.Fragment key={each.booking_id}>
                                        <tr>
                                            <td>
                                                <strong>
                                                    {each.booking_id}
                                                </strong>
                                            </td>
                                            <td>{each.date}</td>
                                            <td>{each.slote}</td>
                                            <td>{each.initiator}</td>
                                            <td>SAR {each.total}</td>
                                            <td>
                                                <Badge
                                                    variant={
                                                        each.status ===
                                                        'Confirmed'
                                                            ? 'success'
                                                            : each.status ===
                                                              'Completed'
                                                            ? 'success light'
                                                            : each.status ===
                                                              'Pending'
                                                            ? 'warning '
                                                            : 'dark text-white '
                                                    }
                                                >
                                                    {each.status}
                                                </Badge>
                                            </td>
                                            <td>
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        variant={
                                                            each.status ===
                                                            'Confirmed'
                                                                ? 'success'
                                                                : each.status ===
                                                                  'Completed'
                                                                ? 'success light'
                                                                : each.status ===
                                                                  'Pending'
                                                                ? 'warning '
                                                                : 'dark text-white '
                                                        }
                                                        className='light sharp i-false'
                                                    >
                                                        {svg1}
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu className='dropdown-menu dropdown-menu-right'>
                                                        <Dropdown.Item
                                                            onClick={() =>
                                                                updateTakeawayStatus(
                                                                    each.booking_id,
                                                                    'restaurant_confirmed'
                                                                )
                                                            }
                                                            className='dropdown-item'
                                                        >
                                                            <i className='las la-check-circle text-success mr-3 scale5' />
                                                            Confirm
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() =>
                                                                updateTakeawayStatus(
                                                                    each.booking_id,
                                                                    'restaurant_cancelled'
                                                                )
                                                            }
                                                            data-dismiss='alert'
                                                            aria-label='Close'
                                                            className='dropdown-item'
                                                        >
                                                            <i className='las la-times-circle text-danger mr-3 scale5' />
                                                            Reject
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() =>
                                                                ViewDetails(
                                                                    each.booking_id
                                                                )
                                                            }
                                                        >
                                                            <i className='las la-eye mr-3 scale5' /> View Details
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                        {expandedRows[each.booking_id] && (
                                            <DeliveryDetails
                                                orderDetails={
                                                    viewDetails[each.booking_id]
                                                }
                                                isLoading={
                                                    loadingDetails[
                                                        each.booking_id
                                                    ]
                                                }
                                                onClose={() =>
                                                    closeDetails(
                                                        each.booking_id
                                                    )
                                                }
                                                bookingId={each.booking_id}
                                            />
                                        )}
                                    </React.Fragment>
                                ))
                            ) : filteredList === null ||
                              filteredList === undefined ? (
                                <tr>
                                    <td colSpan='7'>
                                        <div id='preloader-inner'>
                                            <div className='sk-three-bounce-inner'>
                                                <div className='sk-child sk-bounce1'></div>
                                                <div className='sk-child sk-bounce2'></div>
                                                <div className='sk-child sk-bounce3'></div>
                                                <div id='preloader-inner-bg'></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan='7' className='text-center'>
                                        No takeaway orders found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
};

export default TakeawayList;
